import axios from 'axios'
var Vendor = {};
var _baseVendorURL = `${process.env.VUE_APP_AUTH_API}/vendors`
var _baseVendorRegistrationURL = `${process.env.VUE_APP_AUTH_API}/vendor_registrations`

Vendor.install = function(Vue) {
  Vue.prototype.$vendor = {
    submitRegistration(data, callback, errorCallback) {
      axios({
        method: 'POST',
        url: _baseVendorRegistrationURL,
        data,
        withCredentials: true,
      }).then(
        (response) => callback(response),
        (error) => errorCallback(error.response.data)
      )
    },
    fetchVendorRegistrations(callback, errorCallback) {
      axios({
        method: 'GET',
        url: _baseVendorRegistrationURL,
        withCredentials: true,
      }).then(
        (response) => callback(response),
        (error) => errorCallback(error.response.data)
      )
    },
    fetchVendorRegistration(vendorId, callback, errorCallback) {
      axios({
        method: 'GET',
        url: _baseVendorRegistrationURL + '/' + vendorId,
        withCredentials: true,
      }).then(
        (response) => callback(response),
        (error) => errorCallback(error.response.data)
      )
    },
    updateVendorRegistration(vendorId, params, callback, errorCallback) {
      axios({
        method: 'PATCH',
        url: _baseVendorRegistrationURL + '/' + vendorId,
        params,
        withCredentials: true,
      }).then(
        (response) => callback(response),
        (error) => errorCallback(error.response.data)
      )
    },
    deleteVendorRegistration(vendorId, callback, errorCallback) {
      axios({
        method: 'DELETE',
        url: _baseVendorRegistrationURL + '/' + vendorId,
        withCredentials: true,
      }).then(
        (response) => callback(response),
        (error) => errorCallback(error.response.data)
      )
    },
    updateVendorContact(vendorId, contact, callback, errorCallback) {
      axios({
        method: 'POST',
        url: _baseVendorRegistrationURL + '/' + vendorId + '/point_of_contact',
        data: { contact },
        withCredentials: true,
      }).then(
        (response) => callback(response),
        (error) => errorCallback(error.response.data)
      )
    },
    fetchVendors(params, callback, errorCallback) {
      axios({
        method: 'GET',
        url: _baseVendorURL,
        params,
        withCredentials: true,
      }).then(
        (response) => callback(response),
        (error) => errorCallback(error.response.data)
      )
    },
    fetchVendorIds(callback, errorCallback) {
      axios({
        method: 'GET',
        url: _baseVendorURL,
        withCredentials: true,
        params: { mode: 'simple' }
      }).then(
        (response) => callback(response),
        (error) => errorCallback(error.response.data)
      )
    },
    updateVendor(vendor, callback, errorCallback) {
      axios({
        method: 'PATCH',
        url: _baseVendorURL + '/' + vendor.ID,
        data: { vendor },
        withCredentials: true,
      }).then(
        (response) => callback(response),
        (error) => errorCallback(error.response.data)
      )
    },
    createVendor(vendor, callback, errorCallback) {
      axios({
        method: 'POST',
        url: _baseVendorURL,
        data: { vendor },
        withCredentials: true,
      }).then(
        (response) => callback(response),
        (error) => errorCallback(error.response.data)
      )
    },
  }
}

export default Vendor;
